import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { LIBERTY_MUTUAL_DEFENSE_FEES_QUERY } from '../../../graphql.js'
import { csvUrl, currencyFormatter, getData, getInputParams } from '../CustomUtils.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ResultsGrid from '../ResultsGrid.js'
import ParameterValues from '../ParameterValues.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import TotalsRow from '../TotalsRow.js'

const LIBERTY_MUTUAL_DEFENSE_FEES = gql(LIBERTY_MUTUAL_DEFENSE_FEES_QUERY)

export default function LibertyMutualDefenseFees({ location }) {
  console.log('LibertyMutualDefenseFees rendered', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, LIBERTY_MUTUAL_DEFENSE_FEES, 'libertyMutualDefenseFees', setResults, setGraphQLErrors)
  }, [location])

  let total = 0

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    console.log(results)
    const inputs = getInputParams(location)
    //console.log(inputs)
    const totalColSpan = inputs.showStatus ? 13 : 12
    //console.log(totalColSpan)
    const resultRows = ResultsGrid(results, 0, null, null, null, totalColSpan, currencyFormatter(), number => total += parseFloat(number)*100)
    total /= 100
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('Asbestos/libertyMutualDefenseFees/liberty_mutual', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white'}} >
          <ReportHeading title={'Paid Defense Fees Report'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            {resultRows}
            <TotalsRow columnNumber={totalColSpan} total={total} />
          </tbody>
        </Table>
      </div>
    )
  }
}